import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SupportTicketService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }
  

  ESS_HelpDeskRequest(Detail: any) { 
    return this.http.post<any>(environment.API_URL + `ESS_HelpDeskRequest/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_HelpDeskRequest_Insert(Detail: any) { 
    return this.http.post<any>(environment.API_URL + `ESS_HelpDeskRequest_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ComboLoad(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `FillComboOnMultiple/Selections`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  GeneratePayslip(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GeneratePayslip_Data/GetData`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  GetEmpPayslip(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GetEmpPayslip/MonthYear`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  EmployeePayslipSummary(Detail: any) {
    return this.http.post<any>(environment.API_URL + `EmployeePayslipSummary/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_Uniform(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_Uniform/Report`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ClientPortal_HelpDeskRequest(Detail: any) { 
    return this.http.post<any>(environment.API_URL + `ESS_ClientPortalHelpDeskRequest_Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ClientPortal_HelpDeskRequestUpdate(Detail: any) { 
    return this.http.post<any>(environment.API_URL + `ClientPortalHelpDeskRequest_InsertUpdate`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}